import { render, staticRenderFns } from "./ActuacionesRecibidas.vue?vue&type=template&id=169fd73e"
import script from "./ActuacionesRecibidas.vue?vue&type=script&lang=js"
export * from "./ActuacionesRecibidas.vue?vue&type=script&lang=js"
import style0 from "./ActuacionesRecibidas.vue?vue&type=style&index=0&id=169fd73e&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports